<div class="map-container">
  <div class="map-frame">
    <div id="map" #map [style.height.px]="mapheight"></div>
  </div>
  <div class="elevation-chart-container" *ngIf="showElevationChart && elevationProfile">
    <div #elevationChart class="elevation-chart"></div>
  </div>
</div> 